import React, { useState, useEffect } from "react";
import { Card, Row, Col, Typography, Divider, Space, Button, Tag, List, Spin, Modal, message } from "antd";
import { ArrowRightOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, ExpandOutlined, EyeOutlined } from "@ant-design/icons";
import "../../../assets/dist/ConsumerProject/Consumer/ConsumerPreview.css";
import _consumerService from "../../../modules/consumerService";
import { APP_BLOB_ROOT } from "../../../constants/constants";
import _commonService from "../../../modules/commonService";
import { ExclamationCircleOutlined } from "@ant-design/icons";
// import CommentSection from "../Administrator/CommentSection";
import { COMMON_ERROR_MSG, RECORD_DELETED_MSG } from "../../../constants/constants";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useHistory } from "react-router-dom";
import { routes } from "../../../routes/Routes";
const { Text, Title } = Typography;
const { confirm } = Modal;

const ApplicationDetailsTabForConsumer = ({ activeKey }) => {
  const history = useHistory();
  const [applicantDetails, setApplicantDetails] = useState({});
  const [loading, setLoading] = useState(false);

  let APPLICATION_TYPE_ID = localStorage.getItem("applicationTypeId");

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDocUrl, setSelectedDocUrl] = useState('');
  const [selectedDocName, setSelectedDocName] = useState('');

  useEffect(() => {
    if (activeKey && activeKey == "3") {
      getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
    }
  }, [activeKey]);

  const getApplicantDetailsByID = async (applicationObjId) => {
    setLoading(true);
    try {
      const res = await _consumerService.getConsumerInformationByConsumerId(applicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setApplicantDetails(resObj);
        localStorage.setItem("IsFromConsumerDashboard", JSON.stringify(true));
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const onDocumentEyeClick = (item) => {
    setSelectedDocName(item.name);
    setSelectedDocUrl(item.url);
    setIsModalVisible(true);
  };

  const onDocumentDownloadClick = (item) => {

    if (item === "Personal Financial Statement") {
      if (applicantDetails?.Cons_PFS) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Personal_FinStatement_Path;
        const fileUrl = applicantDetails.Cons_PFS;
        const fileName = applicantDetails.Cons_PFS.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item === "First 2 Pages of Federal Tax Return") {
      if (applicantDetails?.Cons_FederalTax) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path;
        const fileUrl = applicantDetails.Cons_FederalTax;
        const fileName = applicantDetails.Cons_FederalTax.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item == "K-1s") {
      if (applicantDetails?.Cons_K1s) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2;
        const fileUrl = applicantDetails.Cons_K1s;
        const fileName = applicantDetails.Cons_K1s.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item === "Fund Statements or Private Stock Evidence") {
      if (applicantDetails?.Cons_FundStatement) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Credit_Breau_Report_Path;
        const fileUrl = applicantDetails.Cons_FundStatement;
        const fileName = applicantDetails.Cons_FundStatement.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item == "Credit Bureau Report") {
      if (applicantDetails?.Cons_CreditReport) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc3_Credit_Bureau_Report_CBR;
        const fileUrl = applicantDetails.Cons_CreditReport;
        const fileName = applicantDetails.Cons_CreditReport.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else {
      console.error("Unknown document type:", item);
    }
  };

  const deleteDocument = (item) => {
    confirm({
      title: `Are you sure, want to delete this ${item.name}?`,
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        deleteDocumentObj(item.name);
      }
    });
  };

  const deleteDocumentObj = async (item) => {
    console.log("item", item);
    setLoading(true);
    let documentType = "";
    if (item === "Personal Financial Statement") {
      documentType = "levconspfs";
    } else if (item === "First 2 Pages of Federal Tax Return") {
      documentType = "levconsfederaltax";
    } else if (item === "K-1s") {
      documentType = "levconsk1s";
    } else if (item === "Fund Statements or Private Stock Evidence") {
      documentType = "levconsfundstatement";
    } else if (item === "Credit Bureau Report") {
      documentType = "levconscreditreport";
    } else {
      console.error("Unknown document type:", item);
    }

    try {
      const res = await _consumerService.deleteDocumentDataByApplicationId(localStorage.getItem("ApplicationObjId"), documentType);
      if (res.data.IsSuccess) {
        setLoading(false);
        message.success(res.data.Message ? res.data.Message : RECORD_DELETED_MSG);
        getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
      } else {
        setLoading(false);
        message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const onDocumentsEditClick = () => {
    localStorage.setItem("IsFromApplicationStatusTab", false);
    history.push({
      pathname: routes.documentsUpload.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), activeKey },
    });
  }

  const onEditApplicantIdentClick = () => {
    localStorage.setItem("IsFromApplicationStatusTab", false);
    history.push({
      pathname: routes.newLiquidityApplication.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), activeKey },
    });
  }

  const documentMap = {
    "Personal Financial Statement": applicantDetails?.Cons_PFS,
    "First 2 Pages of Federal Tax Return": applicantDetails?.Cons_FederalTax,
    "K-1s": applicantDetails?.Cons_K1s,
    "Fund Statements or Private Stock Evidence": applicantDetails?.Cons_FundStatement,
    "Credit Bureau Report": applicantDetails?.Cons_CreditReport,
  };

  const documents = Object.entries(documentMap)
    .filter(([_, path]) => !!path)
    .map(([name, path]) => ({ name, url: path }));


  console.log("A++", selectedDocUrl)

  return (
    <Spin spinning={loading}>

      <Card
        style={{
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
        }}
        className="mb30 cardViewMain"
        bodyStyle={{ padding: 24 }}
        title={
          <Row justify="space-between" align="middle">
            <Text strong>
              <span role="img" aria-label="user" style={{ marginRight: 8 }}>👤</span>
              Applicant Details
            </Text>
            <EditOutlined onClick={onEditApplicantIdentClick} style={{ color: "#595959", cursor: "pointer" }} />

          </Row>
        }
      >

        <div className="alignment-padding">
          <Row gutter={[24, 24]} className="mt10">
            <Col xs={24} md={8}>
              <Text strong>Use of Proceeds:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Cons_UseofProceeds || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Requested Loan Amount:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Cons_ApproximateLoanSize ?
                `$ ${_commonService.formatNumberWithCommas(applicantDetails.Cons_ApproximateLoanSize)}` : "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Confirm Residency / Jurisdiction:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Cons_ConfirmResidency || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Application Type:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_Application_Type || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>First Name:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_FirstName || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Middle Initial:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_MiddleInitial || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Last Name:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_LastName || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Date Of Birth:</Text> <br />
              <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.App_Det_DateOfBirth || "N/A")}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Contact Number:</Text> <br />
              <Text className="b-bottm">  {applicantDetails?.App_Det_ContactNumber
                ? `(${applicantDetails.App_Det_ContactNumber.slice(0, 3)}) ${applicantDetails.App_Det_ContactNumber.slice(3, 6)}-${applicantDetails.App_Det_ContactNumber.slice(6)}`
                : "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Email:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Email || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">City:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_City || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">State:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_State || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Zip Code:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_ZipCode || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Employer Name:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Prof_Employer_Name || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Position/Title:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Prof_JobRole || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Number of Years with Employer:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Prof_NO_Years || "N/A"}</Text>
            </Col>
          </Row>
          {/* <CommentSection CommentSectionName="aapplicationidentification" applicationstatusid={applicantDetails.Application_Status_Id} /> */}
        </div>
      </Card>

      {documents && documents.length > 0 && (

        <Card
          style={{ borderRadius: 16 }}
          bodyStyle={{ padding: 0 }}
          className="mb30 cardViewMain"
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>🧾</span>
                Documents
              </Text>
              <EditOutlined onClick={onDocumentsEditClick} style={{ color: "#595959", cursor: "pointer" }} />
            </Row>
          }
        >
          {/* List */}
          <div className="alignment-padding DocuementListAdministrator">
            <List
              dataSource={documents}
              renderItem={(item, index) => (
                <List.Item
                  style={{
                    padding: "12px 24px",
                    // backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                    borderBottom: index === documents.length - 1 ? "none" : "1px solid #2e2f30",
                  }}
                  actions={[
                    // <Button icon={<EyeOutlined />} type="text" key="view" onClick={() => onDocumentEyeClick(item)} />,
                    <Button className="iconColor" icon={<DownloadOutlined />} type="text" key="download" onClick={() => onDocumentDownloadClick(item.name)} />,
                    // <Button
                    //   // disabled={["1", "5"].includes(localStorage.getItem("ApplicationStatusId")) ? false : true}
                    //   icon={<DeleteOutlined />}
                    //   type="text" danger key="delete" onClick={() => deleteDocument(item)}
                    // />,

                    ...(["1", "6"].includes(localStorage.getItem("ApplicationStatusId"))
                      ? [
                        // <Button
                        //   className="iconColor"
                        //   icon={<DeleteOutlined />}
                        //   type="text"
                        //   key="delete"
                        //   onClick={() => deleteDocument(item)}
                        // />
                      ]
                      : []
                    )
                  ]}
                >
                  <Space size="middle">
                    <Text strong style={{ width: 24 }}>{`0${index + 1}.`}</Text>
                    <Text>{item.name}</Text>

                  </Space>
                </List.Item>
              )}
            />
            {/* <Divider />
            <Col span={8}>
              <Text type="secondary" >CBR Score:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.CBRScore}</Text>
            </Col> */}
          </div>
          {/* <CommentSection CommentSectionName="personalfinancialstatement" applicationstatusid={applicantDetails.Application_Status_Id} /> */}
        </Card>
      )}
      <Modal
        open={isModalVisible}
        title={selectedDocName}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width="70vw" // Wider
        bodyStyle={{ height: '70vh', padding: 0 }} // Taller
        destroyOnClose
      >
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocUrl)}&embedded=true`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title={selectedDocName}
        />
      </Modal>
    </Spin>
  )
}
export default ApplicationDetailsTabForConsumer;